import { Injectable } from '@angular/core';
// @ts-ignore
import { saveAs } from 'file-saver';

// const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
// const EXCEL_EXTENSION = '.xlsx';
//
// const PDF_TYPE = 'application/pdf';
// const PDF_EXTENSION = '.pdf';
//
// const ZIP_TYPE = 'application/zip';
// const ZIP_EXTENSION = '.zip';

const DOC_TYPE = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
const DOC_EXTENSION = '.docx';

// const DBF_TYPE = 'application/dbf';
// const DBF_EXTENSION = '.dbf';

@Injectable({
  providedIn: 'root'
})

export class SaveFile {
  public docFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {type: DOC_TYPE});
    saveAs(
      data,
      fileName + DOC_EXTENSION
    );
  }
}
